import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

const Svg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <path
      d="M64 960v-128h896v128H64z m512-512h384v128H576v-128z m128-384h256v128h-256V64zM384 704H256V192H64V64h512v128h-192v512z"
      fill="currentColor"
    />
  </svg>
)

const IconComponent = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default IconComponent